import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import HolidayCalenderTable from "../MasterData/HolidayCalenderTable/HolidayCalenderTable";
import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { TableHeader } from "../commons";
import HolidayCalenderTableData from "../MasterData/HolidayCalenderTable/HolidayCalenderTableData";

type AppProps = {
  toggle: () => void;
  data: any;
  isOpen: boolean;
};

export const HOLIDAY_CALENDER_HEADERS: TableHeadersType[] = [
  {
    label: "Description",
    value: "description",
  },
  {
    label: "Date",
    value: "date",
  },
];

const HolidayCalenderModalView = ({ toggle, data, isOpen }: AppProps) => {
  return (
    <Modal
      centered
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      style={{ maxWidth: "540px", width: "100%" }}
      backdrop="static"
    >
      <ModalHeader
        className="pt-3 pl-4"
        id="cross-cut"
        toggle={toggle}
        style={{ paddingBottom: "13px" }}
      >
        View Holidays
      </ModalHeader>
      <ModalBody
        className="pl-4 pr-4"
        style={{ paddingLeft: "40px", minHeight: "70vh", width: "500px" }}
      >
        <div className="jobsType" style={{ width: "90%" }}>
          <table className="table thead-light table-bordered">
            <thead className="text-start sticky-table-header-without-zindex">
              <TableHeader tableHeader={HOLIDAY_CALENDER_HEADERS} />
            </thead>
            <tbody>
              <HolidayCalenderTableData
                data={data}
                tableHeader={HOLIDAY_CALENDER_HEADERS}
              />
            </tbody>
          </table>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default HolidayCalenderModalView;
